/* eslint-disable @typescript-eslint/ban-ts-comment */
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import type { ICategory } from "web/types/Category";
import type { ICategoryCount } from "web/types/CategoryCount";

interface IGetUrlAndCountArgs {
  id: number;
  categories: ICategory[];
  counts: ICategoryCount[];
}

const getUrlAndCount = ({ id, categories, counts }: IGetUrlAndCountArgs) => {
  const currentCategory =
    id &&
    isArrayHasItems(categories) &&
    categories.find((category) => category && +category.id === id);
  const currentProductCount =
    id &&
    isArrayHasItems(counts) &&
    counts.find((item) => item && +item.id === id);
  const url = currentCategory ? `/${currentCategory.request_path}` : null;
  const count = (currentProductCount as ICategoryCount)?.product_count || null;

  return {
    url,
    count,
  };
};

export default getUrlAndCount;
